// extracted by mini-css-extract-plugin
export default {"bio":"TutorBioTabs_bio__haX2P","bioTabs":"TutorBioTabs_bioTabs__1tI0T","bioContent":"TutorBioTabs_bioContent__LvjEq"};